import { Checkbox, Form } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { goalsOptions } from "../../Options/goalsOptions";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";
import "./Goals.css";

const Goals = ({ context, form, data }) => {
  const { formData } = useContext(context);
  const [showOthers, setShowOthers] = useState(
    formData?.goals?.goals?.includes("others") ||
      data?.goals?.goals?.includes("others") ||
      false
  );
  const handleGoals = (values) => {
    if (Array.isArray(values)) {
      setShowOthers(values?.includes("others"));
    }
  };

  useEffect(() => {
    setShowOthers(
      formData?.goals?.goals?.includes("others") ||
        data?.goals?.goals?.includes("others")
    );
  }, [formData]);

  return (
    <>
      <Form.Item label="Goals" name="goals">
        <Checkbox.Group
          className="nutrition-goals-checkbox-group"
          onChange={handleGoals}
        >
          {goalsOptions.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </Form.Item>

      {showOthers && (
        <DynamicInputFields
          field_key={"others"}
          form={form}
          inputStyle={{ maxWidth: "100%", width: "100%" }}
        />
      )}
    </>
  );
};

export default Goals;
